import React, { useEffect, useState } from 'react'
import Snackbar from '@mui/material/Snackbar'

// import LowerPortionImage from '../../assets/images/request-lower.png'
// import UpperPortionImage from '../../assets/images/request-upper.png'
import PhoneImage from '../../assets/images/phone.png'

import { requestCallback } from '../../api'
import constants from '../../constants'
import { programNames } from '../../constants/common'
import InputField from '../InputField'
import Button from '../ButtonNew'
import whiteCurveBg from '../../assets/images/programs/nivolumab/curve-white.svg'
import Text from '../Text'

const RequestCallback = (props) => {
  const { careProgramType = constants.CARE_PROGRAM_TYPE.ANAYA } = props
  const initialValues = { name: '', email: '', phoneNo: '' }
  const [formValues, setFormValues] = useState(initialValues)
  const [touchedFields, setTouchedFields] = useState({
    name: false,
    email: false,
    phoneNo: false,
  })
  const [formErrors, setFormErrors] = useState({})
  const [isSubmit, setIsSubmit] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setTouchedFields({ ...touchedFields, [name]: true })
    setFormValues((prev) => {
      validate({ ...prev, [name]: value })
      return { ...prev, [name]: value }
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const payload = {
      name: formValues?.name,
      email: formValues?.email,
      phone_number: formValues?.phoneNo,
      campaign_type: programNames[careProgramType],
    }
    const response = await requestCallback(payload)

    if (response?.response === 'success') {
      setFormValues(initialValues)
      setTouchedFields({
        name: false,
        email: false,
        phoneNo: false,
      })
      setIsSubmit(true)
    }
  }

  useEffect(() => {
    console.log(formErrors)
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      console.log(formValues)
    }
  }, [formErrors])

  const validate = (values) => {
    const errors = {}
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i
    if (!values.name) {
      errors.name = 'name is required!'
    }
    if (!values.email) {
      errors.email = 'Email is required!'
    } else if (!regex.test(values.email)) {
      errors.email = 'This is not a valid email format!'
    }

    if (!values.phoneNo) {
      errors.phoneNo = 'phone number is required!'
    } else if (values?.phoneNo?.match(/\d/g)?.length !== 10) {
      errors.phoneNo = 'This is not a valid phone number!'
    }
    setFormErrors(errors)
    return errors
  }

  const isFormValid = () => {
    return (
      !formErrors?.email &&
      touchedFields?.email &&
      !formErrors?.name &&
      touchedFields?.name &&
      !formErrors?.phoneNo &&
      touchedFields?.phoneNo
    )
  }

  useEffect(() => {
    if (isSubmit) {
      setTimeout(() => {
        setIsSubmit(false)
      }, 3000)
    }
  }, [isSubmit])

  return (
    <div className="mt-[40px]">
      <Snackbar
        open={isSubmit}
        autoHideDuration={3000}
        message="Form Submitted Succesfully"
      />
      <div
        className={`rounded-lg pb-10 ${careProgramType === constants.CARE_PROGRAM_TYPE.ANAYA ? 'callback-bg-anaya' : 'callback-bg'}`}
      >
        <img
          src={whiteCurveBg}
          alt="nivolumab-hero"
          className="w-full object-cover mb-7"
        />

        <div className="px-5 pt-6 space-y-7">
          <div className="space-y-3">
            <Text tag="p" variant="headline" size="large">
              Request callback
            </Text>

            <Text tag="p" variant="body" size="large">
              {`Have any doubts? Request a callback and our team of care ${careProgramType === constants.CARE_PROGRAM_TYPE.ANAYA ? 'specialists' : 'experts'} will
          help you get your journey started`}
            </Text>
          </div>

          <form
            className="flex flex-col items-center mt-[60px] w-full"
            onSubmit={(e) => handleSubmit(e)}
          >
            {/* Form Fields */}
            <div className="flex flex-col gap-4 w-full">
              <div className="w-full">
                <InputField
                  label="Your name*"
                  value={formValues.name}
                  onChange={handleChange}
                  placeholder="Enter your name"
                  name="name"
                  required
                  error={touchedFields.name && !!formErrors.name}
                  errorMessage={formErrors.name}
                  labelClassName="text-white"
                />
              </div>

              <div className="w-full">
                <InputField
                  label="Email address*"
                  value={formValues.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  name="email"
                  required
                  error={touchedFields.email && !!formErrors.email}
                  errorMessage={formErrors.email}
                  labelClassName="text-white"
                />
              </div>

              <div className="w-full">
                <InputField
                  label="Phone number*"
                  value={formValues.phoneNo}
                  onChange={handleChange}
                  placeholder="Enter your phone number"
                  name="phoneNo"
                  required
                  error={touchedFields.phoneNo && !!formErrors.phoneNo}
                  errorMessage={formErrors.phoneNo}
                  labelClassName="text-white"
                />
              </div>
            </div>

            {/* Submit Button */}
            <div className="w-full text-center relative mt-9">
              <Button
                variant="outlined"
                type="submit"
                disabled={!isFormValid()}
                fullWidth
              >
                Request Callback
              </Button>
            </div>
          </form>
          <div>
            <img
              src={PhoneImage}
              className="w-[250px] max-w-[250px] mx-auto mt-16"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default RequestCallback
